import { useEffect, useState } from "react";
import { _DocumentFactory, _single } from "../../../core/services/dataBean/EntityCatalog"
import useDataBean from "../../../core/services/dataBean/useDataBean"
import { BasicPage } from "../../theme/Component/BasicPage"
import { YearSelector } from "../../../core/shared/inputs/YearSelector";
import { MonthConstantsEditor } from "../../RemoteAbstractAction/editors/MonthConstantsEditor";
import { BasicButton } from "../../theme/Component/BasicButton";
import usePaginator from "../../theme/Component/usePaginator";
import { BasicTable, MASK_BOOLEAN_ICON, MASK_DATE, MASK_DATE_DDMMMYYYY, MASK_NUMBER } from "../../theme/Component/BasicTable";
import { SelectorDocumentFactory } from "./SelectorDocumentFactory";
import { DropDown } from "../../theme/Component/DropDown";
import useModal, { MODAL_SM, MODAL_XL } from "../../theme/Component/hooks/useModal";
import { Modal } from "../../theme/Component/Modal";
import { ExportXLSL } from "../../theme/Component/ExportXLSX";
import AutoChart from "../../../core/graph/AutoChart";


export const ReporteDocumentos = () => {

    const modalExport = useModal("Exportar", MODAL_SM);
    const modalGraph = useModal("Reporte", MODAL_XL);
    const documents = useDataBean(_DocumentFactory);
    const { lista, setLista, bean, setBean } = documents;
    const [listaAll, setListaAll] = useState<any>([]);
    const paginador = usePaginator();
    const [data, setData] = useState<any>({
        DocumentState: 0,
        Year: _single.getCurrenYear(),
        Month: _single.getCurrentMonth()
    });

    useEffect(() => {
        getListaDocument();
    }, [paginador.page])

    const getListaDocument = () => {
        let filtro: any = {
            DocumentState: data.DocumentState
        }
        if (data.Mnemonic != '') {
            filtro.Mnemonic = data.Mnemonic;
        }
        documents.instance.getDocumentInfoReport(paginador.page, 15, data.Year, data.Month, filtro).then(
            (resp: any) => {
                paginador.setPages(resp.NumberOfPages);
                setLista(resp.List);
            }
        )
    }
    const getListaAllDocument = () => {
        let filtro: any = {
            DocumentState: data.DocumentState
        }
        if (data.Mnemonic != '') {
            filtro.Mnemonic = data.Mnemonic;
        }
        documents.instance.getDocumentInfoReport(null, null, data.Year, data.Month, filtro).then(
            (resp: any) => {
                paginador.setPages(resp.NumberOfPages);
                setListaAll(resp.List);
            }
        )
    }

    const head = [
        { title: 'ID', property: 'IDDocument', visible: false, mask: MASK_NUMBER },
        { title: 'Fecha', property: 'DocumentDate', visible: true },
        { title: 'Mnemonic', property: 'Mnemonic', visible: true },
        { title: 'Consecutivo ERP', property: 'Consecutive', visible: true ,mask:MASK_NUMBER},
        { title: 'Consecutivo Externo', property: 'ExternalReference', visible: true ,mask:MASK_NUMBER},
        { title: 'Proceso', property: 'ProcessTypeName', visible: true },
        { title: 'Linea de Negocio', property: 'BussinessLine', visible: true },
        { title: 'Identificacion', property: 'Nit', visible: false },
        { title: 'Elaboro', property: 'EmployeeName', visible: true },
        { title: 'Firmado', property: 'DocumentIsSigned', visible: true, mask: MASK_BOOLEAN_ICON },
    ]

    const actionsDropDown = [
        { id: 1, name: 'Descargar Detallado', permiso: null, activo: true },
        { id: 2, name: 'Reporte Grafico', permiso: null, activo: true },

    ];

    const buttons = () => {
        return (
            <div className="row">
                <div className="col-md-12">
                    {_single.canExport() &&
                        <DropDown lista={actionsDropDown} eventClick={(e) => {
                            if (e.id === 1) {
                                modalExport.open();
                                getListaAllDocument();
                            }
                            else if (e.id === 2) {
                                modalGraph.open();
                                getListaAllDocument();
                            }
                        }}></DropDown>
                    }
                </div>
            </div>
        )
    }

    return (
        <BasicPage titulo="Reporte Documentos">
            <div className="row">
                <div className="col-md-4">
                    <YearSelector value={data.Year} onChange={(e) => { setData({ ...data, "Year": parseInt(e) }) }} />
                </div>
                <div className="col-md-4">
                    <MonthConstantsEditor label="Mes" name="month" idSelect={data.Month} onChange={(e) => { setData({ ...data, "Month": parseInt(e) }) }} />
                </div>
                <div className="col-md-4">
                    <SelectorDocumentFactory label="Tipo de Documento" onChange={(e) => { setData({ ...data, "Mnemonic": e.Mnemonic }) }} />
                </div>
                <div className="col-md-4">
                    <label>Estado Documento</label>
                    <select className="form-select" value={data.DocumentState} onChange={(e) => { setData({ ...data, "DocumentState": parseInt(e.target.value) }) }}>
                        <option value={0}>ACTIVO</option>
                        <option value={1}>ANULADO</option>
                    </select>
                </div>
                <div className="col-md-6 mt-4">
                    <BasicButton icon="" eventClick={getListaDocument}>Buscar</BasicButton>
                </div>
                <div className="col-md-12">
                    <BasicTable headButtons={buttons()} key={paginador.page} head={head} body={lista} rowSet={setBean}
                        pageTop={paginador.page} next={paginador.next} back={paginador.back} records={paginador}
                    ></BasicTable>
                    <Modal modal={modalExport.modal} updateModal={modalExport.setModal}>
                        {lista.length > 0 &&
                            <ExportXLSL customName={"Documentos"} optionIcon="ri-download-cloud-2-line text-success" title={head} data={listaAll} onExport={(name: string) => {
                                _single.download("formato xlsx [" + name + "] con " + lista.length + " registros");
                            }} />
                        }
                    </Modal>
                    <Modal modal={modalGraph.modal} updateModal={modalGraph.setModal}>
                        <AutoChart data={listaAll} head={head} useIndexAsXLabel={true   }
                            xOptions={['DocumentDate','EmployeeName','Mnemonic','ProcessTypeName','BussinessLine']}
                            yOptions={['EmployeeName','Mnemonic','DocumentDate','DocumentIsSigned','ProcessTypeName','BussinessLine']} />
                        {/* <PrintJson json={lista}/> */}
                    </Modal>
                </div>
            </div>
        </BasicPage>
    )
}